import React, { useEffect, useState } from 'react';
import LayoutWithSidebar from '../components/LayoutWithSidebar';
import { fetchDeliveryBoyLogins, updateDeliveryBoyLogin } from '../services/deliveryBoyLoginService';
import { Search, X, Edit } from 'lucide-react';
import { toast } from 'react-toastify';

export default function DeliveryExecutiveLogins() {
  const [logins, setLogins] = useState([]);
  const [search, setSearch] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ email: '', password: '', isActive: '1' });
  const [open, setOpen] = useState(false);

  const loadLogins = async () => {
    try {
      const res = await fetchDeliveryBoyLogins({ search });
      const records = res.data?.data?.records || res.data?.data || [];
      setLogins(records);
    } catch (err) {
      toast.error('Failed to load logins');
    }
  };

  useEffect(() => {
    loadLogins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = (login) => {
    setEditingId(login.id);
    setForm({ email: login.email || '', password: '', isActive: login.isActive ? '1' : '0' });
    setOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        email: form.email,
        isActive: form.isActive === '1',
      };
      if (form.password) payload.password = form.password;
      await updateDeliveryBoyLogin(editingId, payload);
      toast.success('Login updated');
      setOpen(false);
      setEditingId(null);
      setForm({ email: '', password: '', isActive: '1' });
      loadLogins();
    } catch (err) {
      toast.error('Failed to update login');
    }
  };

  return (
    <LayoutWithSidebar>
      <h1 className="text-2xl font-bold mb-4">Delivery App Logins</h1>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 space-y-2 md:space-y-0">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            loadLogins();
          }}
          className="flex items-center relative"
        >
          <Search className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search"
            className="border px-3 py-2 pl-8 pr-8 rounded w-full md:w-64 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
          {search && (
            <button
              type="button"
              onClick={() => {
                setSearch('');
                loadLogins();
              }}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400"
            >
              <X size={16} />
            </button>
          )}
        </form>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white dark:bg-gray-800">
          <thead>
            <tr className="bg-gray-100 dark:bg-gray-700 text-left">
              <th className="py-2 px-3">Delivery Executive</th>
              <th className="py-2 px-3">Email</th>
              <th className="py-2 px-3">Status</th>
              <th className="py-2 px-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {logins.map((login) => (
              <tr key={login.id} className="border-t dark:border-gray-700">
                <td className="py-2 px-3">{login.deliveryBoy?.name || ''}</td>
                <td className="py-2 px-3">{login.email}</td>
                <td className="py-2 px-3">{login.isActive ? 'Active' : 'Inactive'}</td>
                <td className="py-2 px-3">
                  <button className="text-indigo-600" onClick={() => handleEdit(login)}>
                    <Edit size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-25 dark:bg-opacity-50 flex justify-end">
          <div className="relative bg-white dark:bg-gray-800 dark:text-white w-full sm:w-96 h-full p-4 overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl">Edit Login</h2>
              <button onClick={() => setOpen(false)} className="text-gray-600">
                ×
              </button>
            </div>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
              <div>
                <input
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="Email"
                  className="border px-3 py-2 rounded w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
              <div>
                <input
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  placeholder="New Password"
                  className="border px-3 py-2 rounded w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
              <div>
                <select
                  value={form.isActive}
                  onChange={(e) => setForm({ ...form, isActive: e.target.value })}
                  className="border px-3 py-2 rounded w-full dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
              <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded">
                Update
              </button>
            </form>
          </div>
        </div>
      )}
    </LayoutWithSidebar>
  );
}
